import Ext from "Ext";
import _ from "underscore";
import $ from "jquery";
import {AncestorEventsListenerMixin, DescendantEventsEmitterMixin} from "../AncestorEventsMixins";

/**
 * An abstract button with dropdown menu, based on the Ext.Button.
 * The class specifies handles for ESC and ENTER keys press events
 *
 *
 * Methods:
 *  onEnterKeyDown - method to be called when ENTER key press event occurs
 *  onEscKeyDown - method to be called when ENTER key press event occurs
 *
 * Required files:
 *  ExtJS library
 *  util.js
 */
const AbstractDropdownButton = Ext.extend(Ext.Button, {

    scrollHandler: function(){},

    onMenuHide : function(menu)
    {
        AbstractDropdownButton.superclass.onMenuHide.call(this, menu);
        this.restoreWindowKeyDownHandler();
        $( window ).off( "resize.dropdownButton", this.resizeHandler );
        if( this.scrollableContainer )
        {
            $( this.scrollableContainer ).off( "scroll", this.scrollHandler );
        }

        this.triggerDOMEvent("dropdown.menuHide");
    },

    onMenuShow : function(menu)
    {
        AbstractDropdownButton.superclass.onMenuShow.call(this, menu);
        this.setWindowKeyDownHandler();

        var self = this;

        // timeout is needed for fix bug #45198
        setTimeout( function ()
                    {
                        $( window ).off( "resize.dropdownButton", self.resizeHandler );
                        self.resizeHandler = function ()
                        {
                            self.hideMenuOnScrollOrResize();
                        };
                        $( window ).on( "resize.dropdownButton", self.resizeHandler );

                        if( self.scrollableContainer )
                        {
                            $( self.scrollableContainer ).off( "scroll", self.scrollHandler );
                            self.scrollHandler = function ()
                            {
                                self.hideMenuOnScrollOrResize();
                            };
                            $( self.scrollableContainer ).on( "scroll", self.scrollHandler );
                        }
                    }, 100 );

        this.triggerDOMEvent("dropdown.menuShow");
    },

    afterRender: function()
    {
        var self = this;
        var $el = $(this.el.dom);
        this.initDescendantEventsEmitter($el);
        this.initAncestorEventsListener($el, {
            "popup.hide": function()
            {
                self.hideMenu();
                self.disable();
            }
        });
    },

    hideMenuOnScrollOrResize: function()
    {
        this.hideMenu();
    },

    setWindowKeyDownHandler : function ()
    {
        var thisButton = this;
        if ( !this.escKeyMap )
            this.escKeyMap = new Ext.KeyMap(Ext.getBody().parent(), {
                key: Ext.EventObject.ESC,
                fn: function(key, ev){
                    thisButton.onEscKeyDown();
                },
                scope: thisButton,
                stopEvent: true
            });
        if ( !this.enterKeyMap )
            this.enterKeyMap = new Ext.KeyMap(Ext.getBody().parent(), {
                key: Ext.EventObject.ENTER,
                fn: function(key, ev){
                    thisButton.onEnterKeyDown();
                },
                scope: thisButton,
                stopEvent: true
            });
        this.escKeyMap.enable();
        this.enterKeyMap.enable();
    },

    restoreWindowKeyDownHandler : function ()
    {
        if (this.escKeyMap)
        {
            this.escKeyMap.disable();
        }
        if (this.enterKeyMap)
        {
            this.enterKeyMap.disable();
        }
    },

    /**
     *  The method is called if ENTER key is pressed when button's menu is being shown and
     */
    onEnterKeyDown : function ( )
    {
        return false;
    },

    /**
     *  The method is called if ESC key is pressed when button's menu is being shown and
     */
    onEscKeyDown : function ( )
    {
        this.hideMenu();
    }

});
// register xtype
Ext.reg('abstract_dropdown_button', AbstractDropdownButton);

/**
 * Registers potential parent element for dropdown buttons. Should be called once parent element is shown.
 * @param $parentEl Parent element.
 */
AbstractDropdownButton.handleParentShow = function($parentEl)
{
    $parentEl.addClass("atDropdownButtonsParent");
    $parentEl[0].atDropdownButtonsParent = {
        buttons: [],
        hidden: false
    };
};

/**
 * Should be called once parent element is hidden.
 * @param $parentEl Parent element.
 */
AbstractDropdownButton.handleParentHide = function($parentEl)
{
    $parentEl[0].atDropdownButtonsParent.hidden = true;
    _.each($parentEl[0].atDropdownButtonsParent.buttons, function(button) { button.hideMenu(); })
};

_.extend(AbstractDropdownButton.prototype, AncestorEventsListenerMixin, DescendantEventsEmitterMixin);

export default AbstractDropdownButton;


// WEBPACK FOOTER //
// ./web/js/controls/abstract_dropdown_button.js